var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-topic-desc"},[_c('div',{key:"content",staticClass:"topic-content",domProps:{"innerHTML":_vm._s(_vm.content)},on:{"click":function($event){return _vm.getImg($event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }